import React from 'react'

import NavBar from '../../../core/containers/NavBarContainer'

class BtoCLayout extends React.Component {

	constructor(props) { 
        super(props);
    }

    render() {
    	
    	return (
            <div className="layout-provider">
                <NavBar currentRoute={this.props.location.pathname}/>
                {this.props.children}
            </div>
        )
    }
}


export default BtoCLayout



// WEBPACK FOOTER //
// ./src/btoc/components/layout/BtoCLayout.js